<template>
  <v-img :src="source" contain :max-height="32"></v-img>
</template>
<style scoped>

</style>

<script>
  import ImageCell from "./imageCell.ts";
  export default ImageCell;
</script>